<template>
	<div
		@dblclick.capture="$emit('open', order)"
		@click.capture="$emit('select', order)"
		@contextmenu="_onContextMenu"
	>
		<t-card
			background="white"
			elevation="1"
			style="width: 240px; height: 110px;"
			border="default"
			class="order-card"
			:class="{selected: selected, nohover: disableHover}"
		>
			<div slot="header" class="order-card-header">
				<div style="display: flex; align-items: center;">
					<t-timpex-icon :icon="orderIcon" :color="orderIconColor" aspectRatio="square"/>
					<div class="order-card-title">
						{{ orderHeader }}
					</div>
				</div>
				<div class="order-card-title" style="margin-left: auto">
					{{ orderNumber }}
				</div>
				<t-timpex-icon v-if="etcIcon" :color="etcIconColor" size="sm"/>
			</div>
			<div style="flex: 1;">
				<t-destinations-small :from="from" :to="to" :order="true" />
			</div>
		</t-card>
		<t-popover
			ref="contextMenu"
			closeOnClick
			closeOnRightClick
			@open="contextMenuOpen = true"
			@close="contextMenuOpen = false;"
		>
			<slot name="contextMenu" :item="order"/>
		</t-popover>
	</div>
</template>

<script>
import moment from 'moment';
export default {
	name: 'TOrderCard',
	props: {
		/** Order */
		order: Object,
		/** Icon name from TTimpexIcon for order type */
		orderIcon: String,
		/** Color of orders icon */
		orderIconColor: String,
		/** Header text for card */
		orderHeader: String,
		/** Icon name from TTimpexIcon for icon in right corner of header */
		etcIcon: Boolean,
		/** Color for etc icon */
		etcIconColor: String,
		/** Selected */
		selected: Boolean,
		orderNumber: [ String, Number ],
		disableHover: Boolean
	},
	data() {
		return { contextMenuOpen: false, };
	},
	computed: {
		ordersCount() {
			return this.order.orders ? this.order.orders.length : 0;
		},
		from() {
			let party = this.order.despatchParty || this.order.consignor;
			return this.createDestination(party, this.order.etd, this.order.atd);
		},
		to() {
			let party = this.order.deliveryParty || this.order.consignee;
			return this.createDestination(party, this.order.eta, this.order.ata);
		},
	},
	methods: {
		createDestination(party, estimatedDate, actualDate) {
			if (party) {
				return {
					name: party.name,
					place: `${party.postalCode} ${party.postalPlace}`,
					estimatedDate: this.getFormattedDate(estimatedDate),
					actualDate: this.getFormattedDate(actualDate),
				};
			}
			return {};
		},
		getFormattedDate(dateObj) {
			if (dateObj) {
				return moment(dateObj.epoch).format('DD.MM');
			}

			return undefined;
		},
		_onContextMenu(event) {
			let popover = this.$refs.contextMenu;
			if (this.$scopedSlots['contextMenu'] && popover) {
				popover.open({ top: event.clientY, left: event.clientX });
				event.preventDefault();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
.order-card:not(.nohover):hover  {
	box-shadow: 0 0 2px rgba(67, 90, 111, 0.14), 0 0 0 1px #579ad9, 0 0 0 3px rgba(16, 112, 202, 0.14);
	cursor: pointer;
	.order-card-header {
		background-color: #dbeaf7;
		border-color: #dbeaf7;
	}
}
.order-card-header {
	height: 34px;
	padding: 0px 8px 0px 5px;
	background-color: #edf0f2;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #E4E7EB;
}
.order-card-title {
	@extend %text-small;
	font-weight: 600;
	margin-left: 7px;
	color: get-color($text, 'dark');

}
.selected  {
	box-shadow: 0 0 2px get-color($neutral-scale, 'N4A'),
				0 0 0 1px get-color($blue-scale, 'B8'),
				0 0 0 3px get-color($blue-scale, 'B5A') !important;
	cursor: pointer;
	.order-card-header {
		background-color: get-color($blue, 'light');
		border-color: get-color($blue, 'light');
	}
}
</style>


<docs>
```jsx
<div>
	<t-order-card
		orderHeader="Title"
		orderIcon="order"
		orderIconColor="blue"
		:from="{name: 'Terminal Tiller', place: '7038 Tiller', date: '12.12'}"
		:to="{name: 'Terminal Ålesund', place: '6001 Ålesund', date: '20.12'}"
	/>
</div>
```
</docs>